import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';
import PrimeTable from '../../../components/PrimeTable';
import IntFileLogFilterForm from './IntFileLogFilterForm';
import { Button } from 'primereact/button';

const IntFileLogList = () => {

    const { state } = useLocation();
    
    let navigate = useNavigate();

    const dispatch = useDispatch();

    const [dataList, setDataList] = useState([]);

    const [ fileId, setFileId ] = useState(state?.filterByFileId || null);
    
    const intFileLogList = useSelector((state) => state.intFileLog.intfileLogList);

     useEffect(() => {
         if (intFileLogList && intFileLogList?.data?.length > 0) {
             const parsedData = intFileLogList?.data?.map((log) => {
                 try {
                     if (log.logText) {
                         const jsonData = JSON.parse(log.logText);
                         return {
                             ...log,
                             url: jsonData.url || "",
                             request: jsonData.request || "",
                             response: jsonData.response || "",
                         };
                     }
                 } catch (error) {
                     console.error("Error parsing JSON:", error);
                 }
                 return { ...log, url: "", request: "", response: "" };
             });
             setDataList({ ...intFileLogList, data: parsedData });
         } else { 
               setDataList(intFileLogList);
         }
     }, [intFileLogList]);

    const filters = useSelector((state) => state.intFileLog.filters);

    const defaultParams = useMemo(() => {
        return {
            ...filters,
            pageno: 1,
            pagesize: 50,
            sort: 'createdOn',
            logType: "ERROR",
            sortOrder: -1,
            fileId: fileId,
        };
    }, [filters, fileId]); 

    const [formValues, setFormValues] = useState(defaultParams);

    const handleRefresh = useCallback(() => {
        dispatch(appActions.INTFILELOG_GET_ALL_REQUEST(defaultParams));
    }, [dispatch, defaultParams]);

    const handleSearch = useCallback((params) => {
        const searchParams = {
            ...params,
            pagesize: params.pagesize || defaultParams?.pagesize,
            pageno: params.pageno || defaultParams?.pageno,
            sort: params.sort || defaultParams?.sort,
            sortOrder: params.sortOrder || defaultParams?.sortOrder,
            logType: params.logType || defaultParams?.logType,
        };
    
        dispatch(appActions.INTFILELOG_GET_ALL_REQUEST(searchParams));
    }, [defaultParams, dispatch]);

    useEffect(() => {
        handleSearch(defaultParams);
    }, []); // Empty dependency array ensures it runs only on mount

    const handleViewRedirect = useCallback((record) => {
        const data = dataList?.data?.find(t => t.id === record.id);
        navigate('/ui/integration-file-log/detail', { state: { data, isView: true } });
    }, [dataList, navigate]);
    
    const handleFormValuesChange = (values) => {
        setFormValues(values);
        setFileId(values?.fileId);
    };

    const renderHeader = () => {
        return (
            <div className="d-flex flex-row gap-10 align-items-center">
                <h1 className="page-header flex">Integration File Log</h1>
                <Button icon="pi pi-sync" rounded text aria-label="Refresh" className='mr-auto tp' data-pr-tooltip="Refresh" onClick={handleRefresh} />
                {/* <DownloadFile 
                    filePath={'/usr/dxp/logs/dxp-vssap-service.log'} 
                    tooltipText={'Download Application logs'}
                    btnLabel="App Logs"/> */}
            </div>
        );
    };

    const actionTemplate = useCallback(
        (rowData) => (
            <div className="flex gap-10 justify-content-center">
                <span className="cursor-pointer tp" onClick={() => handleViewRedirect(rowData)} data-pr-tooltip="View">
                    <i className="pi pi-eye text-blue-500 text-base"></i>
                </span>
            </div>
        ),
        [handleViewRedirect],
    );

    const onFilterChangeCallback  = useCallback(
        (e) => {

            const { sortField, sortOrder, rows, page } = e;
            
            const params = {...formValues, pagesize: rows, pageno: page, sort: sortField, sortOrder: sortOrder };

            setFormValues(prevFormValues => ({
                ...prevFormValues,
                sort: sortField, 
                sortOrder: sortOrder,
                pagesize: rows,
                pageno: page
            }));

            handleSearch(params); // Call search with updated sorting params
        },
        [handleSearch, formValues],
    );

    const parseLogText = (logText) => {
        try {
            const json = JSON.parse(logText);
            if (typeof json === 'object' && json !== null) {
                return json?.response;
            }else{
                return logText
            }
        } catch (e) {
            return '';
        }
    }

    const logTextTemplate = row => {
        const { logText } = row
        const logTestStr = parseLogText(logText)
        return logTestStr
    }
    
    const columns = [
        { field: 'fileId', header: 'File ID', sortable: true, width: '120px', },
        { field: 'storeId', header: 'Store ID', sortable: true , width: '110px',},
        { field: 'logGroup', header: 'Log Group', sortable: true, width: '110px', },
        { field: 'logType', header: 'Log Type', width: '120px', },
        { field: 'logText', header: 'Log Text', sortable: true},
        // { field: 'url', header: 'URL', sortable: true},
        // { field: 'request', header: 'Request', sortable: true, template: logTextTemplate },
        // { field: 'response', header: 'Response', sortable: true, template: logTextTemplate },
        { field: 'createdOn', header: 'Created On', sortable: true, width: '120px', maxWidth: "150px", columnType: 'datetime' },
        // { field: 'lastUpdated', header: 'Last Updated', sortable: true, columnType : 'datetime' },
        // { field: 'lastUpdatedBy', header: 'Last Updated By', sortable: true },
    ];

    const renderList = () => {
        return (
            <>
                <div className='pv-15 ph-15'> {renderHeader()} </div>
                <div className="bg-white mx-3 pv-15 ph-15 br-6 shadow-white">
                    <IntFileLogFilterForm 
                        handleSearch={handleSearch} 
                        handleReset={handleRefresh} 
                        onFormValuesChange={handleFormValuesChange} 
                    />
                    <div className='custom-devider'></div>
                    <PrimeTable
                        list={dataList}
                        columns={columns}
                        actionColumn={actionTemplate}
                        onFilterChangeCallback={(e) => {
                            onFilterChangeCallback(e);
                        }}
                        tableName='integration_file_logs'
                        isLazy={true}
                    />
                </div>
            </>
        );
    };

    return <div className="form_height">{renderList()}</div>;
};

export default IntFileLogList;
